import { render } from "./StarredPage.vue?vue&type=template&id=5e323302&scoped=true"
import script from "./StarredPage.vue?vue&type=script&lang=js"
export * from "./StarredPage.vue?vue&type=script&lang=js"

import "./StarredPage.vue?vue&type=style&index=0&id=5e323302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e323302"]])

export default __exports__